import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button, Modal } from "@similarweb/ui-components";

import { useMetricWidgetContext } from "./MetricWidgetContext";

const customModalStyles = {
    content: {
        width: "600px",
    },
};

interface IMetricWidgetModalProps {
    title: string;
    automationId: string;
    children: ReactNode;
}

export const MetricWidgetModal = ({ title, automationId, children }: IMetricWidgetModalProps) => {
    const { translate } = useTranslate();
    const {
        state: { isModalOpen, hasOthers },
        actions: { closeModal },
    } = useMetricWidgetContext();

    if (!hasOthers) {
        return null;
    }

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            customStyles={customModalStyles}
            data-automation={automationId}
        >
            <Modal.Header withBorder>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Content padding="0">{children}</Modal.Content>
            <Modal.Footer withBorder>
                <Button
                    onClick={closeModal}
                    data-automation={`${automationId}-close-button`}
                >
                    {translate("common.close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
